(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maison-product-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maison-purchase')) customElements.define('maison-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('[name="quantity"]');
      this.accessory = this.querySelector('[data-accessory]');
      this.error = this.querySelector('[role="alert"]');
      this.addEventListener('change', event => {
        if (event.target.name === 'id') {
          const selected = this.selected;
          this.quantity.min = selected.dataset.min;
          this.quantity.step = selected.dataset.increment;
          if (selected.dataset.max) this.quantity.max = selected.dataset.max; else this.quantity.removeAttribute('max');
          this.quantity.value = selected.dataset.min;
          const url = new URL(location.href);
          url.searchParams.set('variant', selected.value);
          history.replaceState({},'',url);
        }
        this.updateTotal();
      });
      this.addEventListener('input',event=>{if(event.target === this.quantity) this.updateTotal();});
      this.addEventListener('click',event=>{
        const step = event.target.closest('[data-step]');
        if (!step || this.busy) return;
        if (step.dataset.step === '1') this.quantity.stepUp(); else this.quantity.stepDown();
        this.updateTotal();
      });
      this.form.addEventListener('submit',async event=>{
        event.preventDefault();
        if (this.busy || !this.form.reportValidity() || !this.selected || this.selected.disabled) return;
        this.busy = true;
        this.error.hidden = true;
        const items = [{id:Number(this.selected.value),quantity:Number(this.quantity.value)}];
        if (this.accessory?.checked) items.push({id:Number(this.accessory.value),quantity:1});
        this.querySelectorAll('button,input').forEach(el=>{el.dataset.wasDisabled=String(el.disabled);el.disabled=true;});
        this.setAttribute('aria-busy','true');
        try {
          const response = await fetch(this.dataset.root.replace(/\/?$/,'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:AbortSignal.timeout(15000)});
          const data = await response.json().catch(()=>({}));
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          const cartUrl = new URL(this.dataset.cart,location.origin);
          const previewId = new URL(location.href).searchParams.get('preview_theme_id');
          if(previewId) cartUrl.searchParams.set('preview_theme_id',previewId);
          location.assign(cartUrl);
        } catch (error) {
          this.error.textContent = error.name === 'TimeoutError' || error.name === 'TypeError' ? this.dataset.error : error.message;
          this.error.hidden = false;
          this.busy = false;
          this.removeAttribute('aria-busy');
          this.querySelectorAll('button,input').forEach(el=>{el.disabled=el.dataset.wasDisabled==='true';delete el.dataset.wasDisabled;});
        }
      });
      this.updateTotal();
    }
    get selected(){return this.querySelector('input[name="id"]:checked');}
    updateTotal(){
      const selected=this.selected;
      const button=this.querySelector('[type="submit"]');
      if(!selected || selected.disabled){button.disabled=true;return;}
      button.disabled=this.busy || !this.quantity.checkValidity();
      const amount=Number(selected.dataset.price)*Number(this.quantity.value)+(this.accessory?.checked?Number(this.accessory.dataset.price):0);
      this.querySelector('[data-submit-label]').textContent=this.dataset.add+' · '+new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(amount/100);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
